
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulicPipe09 as ObiHydraulicPipe09Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-pipe-09.js';
 
 
 

 
 export const ObiHydraulicPipe09 = createComponent({
   react: React,
   tagName: 'obi-hydraulic-pipe-09',
   elementClass: ObiHydraulicPipe09Element,
   events: {
     
   }
  });
 
 